import { useQuery } from "react-query";
import { getAgreements } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAgreementsRepo = () => {
  return useQuery(["GetMainAgreements", null], getAgreements, {
    refetchOnWindowFocus: false,
  });
};

export default useAgreementsRepo;

// staleTime: 180 * 1000, // 3 minutes
